var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8QrCode50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3F51B5",
    d: "M10 10H14V14H10zM10 32H14V36H10zM32 10H36V14H32zM20 20H24V24H20zM24 20H28V24H24zM24 28H28V32H24zM38 24H42V28H38zM8 24H12V28H8zM16 24H20V28H16zM12 20H16V24H12zM20 24H24V28H20zM24 32H28V38H24zM30 30H34V34H30zM20 31H24V35H20zM20 38H24V42H20zM30 24H34V28H30zM26 24H30V28H26zM30 38H34V42H30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F51B5",
    d: "M26 24H30V28H26zM38 30H42V34H38zM38 38H42V42H38zM34 34H38V38H34zM22 24H26V28H22zM34 20H38V24H34zM26 4v16h16V4H26zM38 16h-8V8h8V16zM4 20h16V4H4V20zM8 8h8v8H8V8zM4 42h16V26H4V42zM8 30h8v8H8V30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8QrCode50);
export default __webpack_public_path__ + "static/media/icons8-qr-code-50.8c0df289eb64103a6d0eacc631854002.svg";
export { ForwardRef as ReactComponent };